









































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Devis} from '@/models';

import CrudDevisFilter from '@/components/Crud/Devis/Filter.vue';
import CrudDevisEditDialog from '@/components/Crud/Devis/EditDialog.vue';
import CrudDevisList from '@/components/Crud/Devis/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeDevis, {DevisFilter} from '@/stores/modules/devis';

@Component({
	components: {
		CrudDevisFilter,
		CrudDevisEditDialog,
		CrudDevisList,
		CrudDeleteDialog,
	}
})
export default class DevisView extends Vue {

	@Stored(() => storeDevis) private devis!: ResultType<Devis>;
	@Stored(() => storeDevis) private filters!: DevisFilter;

	private imgPath: string = "";

	private editDevis: Devis = null;
	private deletedDevis: Devis = null;
	private storeDevis = storeDevis;
	private list;

	public mounted() {
		this.list = this.$refs['list'] as CrudDevisList
	}

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editDevis = new Devis();
		this.refresh();
	}

	private refresh(): void {
		storeDevis.dispatch('getC', { filters: true });
	}
}
